var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"registrants"}},[_vm._v("\n  View My Registrants Details\n")])}
var staticRenderFns = []

export { render, staticRenderFns }